// extracted by mini-css-extract-plugin
module.exports = {"switcher":"CountrySwitcher-module__switcher___3991V"};